import { createTheme } from "@mui/material";


 export const Theam = createTheme({
    palette:{
        primary:{
            main:"#0164AE"
        }
    }
})